import { render, staticRenderFns } from "./EmailReminderDialog.vue?vue&type=template&id=e3b7d51a&scoped=true"
import script from "./EmailReminderDialog.vue?vue&type=script&lang=js"
export * from "./EmailReminderDialog.vue?vue&type=script&lang=js"
import style0 from "./EmailReminderDialog.vue?vue&type=style&index=0&id=e3b7d51a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3b7d51a",
  null
  
)

export default component.exports